<template
  :pendentes="pendentes"
  :ativas="ativas"
  :inativas="inativas"
>
  <div>
    <v-row class="mb-5">
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card class="filtros" @click="filtrar('Pendente')">
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ pendentes }}
              </h2>
              <span>Pendentes</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg primary--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="primary"
              >
                {{ icons.mdiAccountClockOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card class="filtros" @click="filtrar('Inativa')">
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ inativas }}
              </h2>
              <span>Inativas</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg primary--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="primary"
              >
                {{ icons.mdiAccountOffOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card class="filtros" @click="filtrar('Ativa')">
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ ativas }}
              </h2>
              <span>Ativas</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg success--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="success"
              >
                {{ icons.mdiAccountCheckOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mdiAccountCheckOutline, mdiAccountOffOutline, mdiAccountClockOutline,
} from '@mdi/js'

export default {
  props: {
    pendentes: {
      type: Number,
      default: () => 0,
    },
    ativas: {
      type: Number,
      default: () => 0,
    },
    inativas: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({

    icons: {
      mdiAccountCheckOutline,
      mdiAccountOffOutline,
      mdiAccountClockOutline,
    },
  }),


  methods: {
    filtrar(item){
      this.$emit('alterarFiltro', item)
    }
  }

}
</script>

<style>
  .filtros{
    cursor: pointer;
  }
  .filtros:hover{
    background-color: rgba(240, 248, 255, 0.094);
  }
</style>

